import { render, staticRenderFns } from "./ShortcutCard.vue?vue&type=template&id=130e7642&"
import script from "./ShortcutCard.vue?vue&type=script&lang=js&"
export * from "./ShortcutCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports